module.exports = __webpack_public_path__ + "87955ad43aaf700cc7240d1419137475.png";